module.exports = __webpack_public_path__ + "img/badge-1.b60dfa1f.svg";